<template>
  <j-modal :title="title" v-dragModal width="60%" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container>
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-descriptions :title="$t('问题详情')">
                <a-descriptions-item :label="$t('上报人')">{{ model.informant }}</a-descriptions-item>
                <a-descriptions-item :label="$t('上报人电话')">{{ model.informantPhone }}</a-descriptions-item>
                <a-descriptions-item :label="$t('现场坐标')">{{ model.coordinate }}</a-descriptions-item>
                <a-descriptions-item :label="$t('问题等级')">{{
                    filterDictTextByCache('problemLevel',model.problemLevel)
                  }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备编号')">{{ model.deviceNum }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备名称')">{{ model.deviceName }}</a-descriptions-item>
                <a-descriptions-item :label="$t('设备类型')">{{
                  filterDictTextByCache('deviceType', model.deviceType)
                }}</a-descriptions-item>
                <a-descriptions-item :label="$t('创建时间')">{{ model.createTime }}</a-descriptions-item>
              </a-descriptions>
              <a-descriptions :column="1">
                <a-descriptions-item :label="$t('问题描述')">{{ model.exceptionDescription }}</a-descriptions-item>
                <a-descriptions-item :label="$t('处理前图片或视频')"></a-descriptions-item>
              </a-descriptions>
              <div class="img-list">
                <div
                  class="img-box"
                  v-for="(item, index) in model.inspectionTaksRouteDeviceFilePaths"
                  :key="index"
                  @click="viewPicture(item)"
                  v-if="item.type==1"
                >
                  <div v-if="item.type==1">
                    <img :src="item.url" alt="" v-if="item.fileType == 'image'" />
                    <video controls :src="item.url" alt="" v-if="item.fileType == 'video'"></video>
                  </div>
                </div>
              </div>
              <a-descriptions :column="1" v-if="model.whetherToSolve==1">
                <a-descriptions-item :label="$t('处理后图片或视频')"></a-descriptions-item>
              </a-descriptions>
              <div class="img-list" v-if="model.whetherToSolve==1">
                <div
                  class="img-box"
                  v-for="(item, index) in model.inspectionTaksRouteDeviceFilePaths"
                  :key="index"
                  @click="viewPicture(item)"
                  v-if="item.type==2"
                >
                  <div v-if="item.type==2">
                    <img :src="item.url" alt="" v-if="item.fileType == 'image'" />
                    <video controls :src="item.url" alt="" v-if="item.fileType == 'video'"></video>
                  </div>
                </div>
              </div>
              <a-descriptions :column="2">
                <a-descriptions-item :label="$t('是否现场已解决')">
                  <a-tag :color="model.whetherToSolve==1?'green':model.whetherToSolve==2?'red':''">
                    {{ model.whetherToSolve==1?$t('已解决'):model.whetherToSolve==2?$t('未解决'):'' }}
                  </a-tag>
                </a-descriptions-item>
                <a-descriptions-item :label="$t('处理人')" v-if="model.whetherToSolve==1">{{ model.informant }}</a-descriptions-item>
              </a-descriptions>
            </a-col>
          </a-row>
          <template v-if="model.whetherToSolve==2">
            <a-row :gutter="24">
              <a-col :span="24">
                <a-divider orientation="left">{{ $t('确认信息') }}</a-divider>
                <a-form-model-item :label="$t('是否开启工单')" prop="ifNeedCreateTickets">
                  <a-radio-group v-model="model.ifNeedCreateTickets">
                    <a-radio :value="1">{{ $t('是') }}</a-radio>
                    <a-radio :value="0">{{ $t('否') }}</a-radio>
                  </a-radio-group>
                </a-form-model-item>
              </a-col>
            </a-row>
            <!-- 生成工单 -->
            <template v-if="model.ifNeedCreateTickets == 1">
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('工单类型')" prop="ticketsType">
                    <a-select v-model="model.ticketsType" :placeholder="$t('请选择工单类型')" disabled>
                      <a-select-option :value="2">{{ $t('故障报修') }}</a-select-option>
                      <a-select-option :value="11">{{ $t('水厂报修') }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('工单联系人')" prop="ticketsContact">
                    <a-input v-model="model.informant" :placeholder="$t('请输入工单联系人')" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('联系电话')" prop="ticketsContactPhone">
                    <a-input v-model="model.informantPhone" :placeholder="$t('请输入联系电话')"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-model-item :label="$t('紧急程度')" prop="ticketsEmergency">
                    <j-dict-select-tag v-model="model.ticketsEmergency" :placeholder="$t('请选择工单紧急程度')" dictCode="ticketsEmergency" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('地理信息')" prop="repairAddress">
                    <a-input v-model="model.coordinate" :placeholder="$t('请输入工单位置')" disabled></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <a-form-model-item :label="$t('预约时间')" prop="dealTime">
                    <a-date-picker show-time v-model="model.dealTime" valueFormat="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </template>
            <!-- 不生成工单 -->
            <template v-if="model.ifNeedCreateTickets == 0">
              <a-row :gutter="24" >
                <a-col :span="24">
                  <a-form-model-item :label="$t('处理人')" prop="userId">
                    <j-select-user-by-dep v-model="model.userId" :multi="false" :isGg="true" @change="userChange" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="24">
                  <a-form-model-item :label="$t('审批描述')" prop="reason">
                    <a-textarea v-model="model.reason" :rows="3" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </template>
          </template>
        </a-form-model>
      </j-form-container>
    </a-spin>
    <j-modal
      :title="$t('预览')"
      :body-style="{ height: '480px' }"
      :visible="visiblePirture"
      :maskClosable="false"
      @cancel="visiblePirture = false"
      :okButtonProps="{ class: { 'jee-hidden': true } }"
    >
      <img :src="viewUrl" alt="" style="width: 100%; height: 100%" />
    </j-modal>
  </j-modal>
</template>

<script>
  import {
    httpAction,
    getAction,
    postAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import {PhoneNumberPattern} from '@/utils/regPattern'
  import JImageUpload from '@/components/jeecg/JImageUpload.vue'
  import JSelectUserByDep from "@/components/jeecgbiz/JSelectUserByDep"
  import { filterDictTextByCache } from '@/components/dict/JDictSelectUtil'
  import JSearchSelectTag from '../../../components/dict/JSearchSelectTag.vue'
  export default {
    name: 'confirmModal',
    components: {
      JImageUpload,
      JSelectUserByDep,
      JSearchSelectTag
    },
    data() {
      return {
        filterDictTextByCache: filterDictTextByCache,
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        confirmLoading: false,
        model: {},
        url: {
          createTicket: "/jeecg-engineering/ticket/tickets/createTicket",
          edit: "/jeecg-engineering/InspectionWorkOrderController/exampleModifyTheInspectionWorkOrder",
          workOrderDetails: '/jeecg-engineering/InspectionWorkOrderController/workOrderDetails',
        },
        visiblePirture: false,
        viewUrl: '',
      }
    },
    computed: {
      validatorRules () {
        return {
          ifNeedCreateTickets: [{
            required: true,
            message: this.$t('请选择是否开启工单'),
            trigger: 'change'
          }],
          response: [{
            required: true,
            message: this.$t('请输入回复内容'),
            trigger: 'blur'
          }],
          ticketsEmergency: [{ required: true, message: this.$t('请选择紧急程度'), trigger: 'change' }],
          userId: [
            { required: true, message: this.$t('请选择处理人'), trigger: 'change' }
          ],
          reason: [
            { required: true, message: this.$t('请输入审批描述'), trigger: 'change' }
          ]
        }
      }
    },
    methods: {
      userChange(id,name){
        this.$set(this.model, 'userId', id)
        this.$set(this.model, 'userName', name)
      },
      init(row){
        this.title = this.$t('确认');
        this.visible = true;
        getAction(this.url.workOrderDetails, { id: row.id }).then(res => {
          if (res.success) {
            this.model = Object.assign({}, res.result)
            this.$set(this.model,'ticketsType',this.model.source==1?11:2);
          }else{
            this.$message.error(res.message)
          }
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        const that = this;
        if(this.model.whetherToSolve == 1){
          this.$refs.form.validate(valid => {
            if (valid) {
              this.confirmLoading = true
              let params = JSON.parse(JSON.stringify(this.model))
              params.status = 4;
              httpAction(this.url.edit, params, 'post').then((res) => {
                if (res.success) {
                  this.$message.success(res.message)
                  this.confirmLoading = false
                  this.close()
                  this.$emit('ok')
                }else{
                  this.$message.warning(res.message)
                }
              })
            }
          })
        }else{
          if(this.model.ifNeedCreateTickets==1){//生成一个报修工单
            // 触发表单验证
            that.$refs.form.validate(valid => {
              if (valid) {
                that.confirmLoading = true;
                let repairPicture = that.model.inspectionTaksRouteDeviceFilePaths&&that.model.inspectionTaksRouteDeviceFilePaths.filter(item=> item.fileType== 'image').map(item => item.url ).join(',')
                let params = Object.assign({}, that.model,{
                  ifNeedCreateTickets:  that.model.ifNeedCreateTickets,
                  createTicketDTO: {
                    ticketsFrom: "Inspection",
                    sourceType: 0,
                    ticketsType: that.model.ticketsType,
                    ticketsEmergency: that.model.ticketsEmergency,
                    dealTime: that.model.dealTime,
                    repairPicture: repairPicture,
                    InspectionWorkOrderId: that.model.id,
                    ticketsRepairReq: {
                      repairName: that.model.informant,
                      repairPhone: that.model.informantPhone,
                      repairAddress: that.model.coordinate,
                      repairDescription: that.model.exceptionDescription,
                    },
                    source: that.model.source,
                  }
                });
                postAction(this.url.edit, params).then((res) => {
                  if (res.success) {
                    that.$message.success(res.message || that.$t('生成工单成功！'));
                    that.$emit('ok');
                    this.visible = false;
                  } else {
                    that.$message.warning(res.message);
                  }
                }).finally(() => {
                  that.confirmLoading = false;
                })
              }
            })
          }else{
            this.$refs.form.validate(valid => {
              if (valid) {
                this.confirmLoading = true
                let params = JSON.parse(JSON.stringify(this.model))
                params.ifNeedCreateTickets = that.model.ifNeedCreateTickets,
                params.status = 1;
                httpAction(this.url.edit, params, 'post').then((res) => {
                  if (res.success) {
                    this.$message.success(res.message)
                    this.confirmLoading = false
                    this.close()
                    this.$emit('ok')
                  }else{
                    this.$message.warning(res.message)
                  }
                })
              }
            })
          }
        }
      },
      handleCancel() {
        this.close()
      },
      handleCancel() {
        this.close()
      },
      viewPicture(item) {
        if (item.fileType == 'image') {
          this.visiblePirture = true
          this.viewUrl = item.url
        }
      },
    }
  }
</script>
<style lang="less" scoped>
.img-list {
  display: flex;
  .img-box {
    width: 150px;
    height: 150px;
    margin: 5px;
    cursor: pointer;
    border-radius: 4px;
    div{
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
      video {
        width: 100%;
        height: 100%;
        border-radius: 4px;
      }
    }
  }
}
</style>